<template>
  <div class='beacons'>
    <beaconsList></beaconsList>
    <router-view/>
  </div>
</template>

<script>
import beaconsList from './beaconsList.vue'

export default {
  components: {
    beaconsList
  }
}
</script>
<style scoped>
.beacons {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/beacons/beacons.vue